import React, { useState } from 'react';
import { MenuIcon, XIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="flex flex-col items-center py-6" data-id="element-86">
          {/* Logo - Centered */}
          <a href="/" className="text-center mb-6" data-id="element-87">
            <h1 className="text-2xl sm:text-3xl font-serif font-bold text-black tracking-wide" data-id="element-88">
              Gardendale
            </h1>
            <p className="text-sm text-gray-600 italic font-light tracking-widest" data-id="element-89">
              VENUE
            </p>
          </a>

          {/* Desktop Navigation Row with Social Icons and CTA */}
          <div className="hidden lg:grid lg:grid-cols-3 items-center w-full max-w-6xl gap-8" data-id="element-90">
            {/* Social Icons - Left */}
            <div className="flex items-center gap-4 justify-start" data-id="element-91">
              <a href="#" className="text-gray-600 hover:text-black transition-colors" data-id="element-92">
                <InstagramIcon className="w-5 h-5" data-id="element-93" />
              </a>
              <a href="#" className="text-gray-600 hover:text-black transition-colors" data-id="element-94">
                <FacebookIcon className="w-5 h-5" data-id="element-95" />
              </a>
            </div>

            {/* Navigation - Center */}
            <nav className="flex items-center justify-center gap-8" data-id="element-96">
              <a href="#home" className="text-sm text-gray-700 hover:text-black tracking-wider transition-colors whitespace-nowrap" data-id="element-97">
                HOME
              </a>
              <a href="#about" className="text-sm text-gray-700 hover:text-black tracking-wider transition-colors whitespace-nowrap" data-id="element-98">
                ABOUT
              </a>
              <a href="#gallery" className="text-sm text-gray-700 hover:text-black tracking-wider transition-colors whitespace-nowrap" data-id="element-99">
                GALLERY
              </a>
              <a href="#pricing" className="text-sm text-gray-700 hover:text-black tracking-wider transition-colors whitespace-nowrap" data-id="element-100">
                PRICING & PACKAGES
              </a>
              <a href="#events" className="text-sm text-gray-700 hover:text-black tracking-wider transition-colors whitespace-nowrap" data-id="element-101">
                EVENTS
              </a>
              <a href="#contact" className="text-sm text-gray-700 hover:text-black tracking-wider transition-colors whitespace-nowrap" data-id="element-102">
                CONTACT
              </a>
            </nav>

            {/* CTA Button - Right */}
            <div className="flex justify-end" data-id="element-103">
              <a href="#contact" className="bg-black text-white px-6 py-2.5 text-sm tracking-wider hover:bg-gray-800 transition-colors whitespace-nowrap" data-id="element-104">
                BOOK A TOUR
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden absolute right-4 top-8 text-gray-700" data-id="element-105">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-106" /> : <MenuIcon className="w-6 h-6" data-id="element-107" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100" data-id="element-108">
          <nav className="flex flex-col px-4 py-6 gap-4" data-id="element-109">
            <a href="#home" className="text-sm text-gray-700 tracking-wider py-2" data-id="element-110">
              HOME
            </a>
            <a href="#about" className="text-sm text-gray-700 tracking-wider py-2" data-id="element-111">
              ABOUT
            </a>
            <a href="#gallery" className="text-sm text-gray-700 tracking-wider py-2" data-id="element-112">
              GALLERY
            </a>
            <a href="#pricing" className="text-sm text-gray-700 tracking-wider py-2" data-id="element-113">
              PRICING & PACKAGES
            </a>
            <a href="#events" className="text-sm text-gray-700 tracking-wider py-2" data-id="element-114">
              EVENTS
            </a>
            <a href="#contact" className="text-sm text-gray-700 tracking-wider py-2" data-id="element-115">
              CONTACT
            </a>
            <div className="flex items-center gap-4 pt-4 border-t border-gray-100" data-id="element-116">
              <a href="#" className="text-gray-600" data-id="element-117">
                <InstagramIcon className="w-5 h-5" data-id="element-118" />
              </a>
              <a href="#" className="text-gray-600" data-id="element-119">
                <FacebookIcon className="w-5 h-5" data-id="element-120" />
              </a>
            </div>
            <a href="#contact" className="bg-black text-white px-6 py-3 text-sm tracking-wider text-center mt-2" data-id="element-121">
              BOOK A TOUR
            </a>
          </nav>
        </div>}
    </header>;
}